/**
 * @generated SignedSource<<d05f5661a543c9dea369cd0abff9e776>>
 * @relayHash 06aae4b857d472d49c20b89675d9ed47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 84121efe42b89a0425a171da93fe93364023bb9c0667eae4a91e58bea9803fa6

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import shouldFetchProjectAccess_provider from '@atlassian/jira-relay-provider/src/jira-is-fetch-accesslevel-for-split-share-button-enabled.relayprovider';
import fetchTeamCount_provider from '@atlassian/jira-relay-provider/src/jira-team-button-team-count.relayprovider';
import showTeamButton_provider from '@atlassian/jira-relay-provider/src/jira-team-button.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "84121efe42b89a0425a171da93fe93364023bb9c0667eae4a91e58bea9803fa6",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonrelayprovider": showTeamButton_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": fetchTeamCount_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider": shouldFetchProjectAccess_provider
    }
  }
};

export default node;
